module.exports = __webpack_public_path__ + "static/media/rni-logo.078a818b.png";